import React from "react";
import { withRouter, Link } from "react-router-dom";
import { Modal, ModalBody, Row, Col } from 'reactstrap';
import Abstract2 from "corp-site/employer/Abstracts/Abstract2";

import PostToBoards from "../../employer/components/PostToBoards";

import PricingMainImage from "./PricingMainImage"

const PricingOverlay = ({ history }) => {


    const onCloseModal = () => {
        history.push("/employers");
    };

    return (
        <Modal isOpen={true} className="pricing-overlay rounded_modal modal-lg" toggle={onCloseModal}>
            <ModalBody>
                <section className="pricing_post_a_job">
                    <button type="button" onClick={onCloseModal} className="close modalClose" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                    <h3>Post a job starting at just <span>$50!</span></h3>
                    <Row>
                        <Col xs="12" lg="6" >
                            <PricingMainImage />
                        </Col>
                        <Col xs="12" lg="6" className="text-center">
                            <div className="price_range_text">
                                <p>When it comes to hiring, one size does not always fit all. We let you choose your own price and we will predict the range of clicks you will get.</p>
                                <p>We predict the range of job clicks you will get for your chosen posting price.</p>
                                <br />
                                <Link to="?register=y" className="btn btn-xl btn-block btn-dark-orange btn-rounded"> Post your job </Link>
                            </div>
                        </Col>
                    </Row>
                </section>
                <section className="pricing_how_it_works upward_vertical_getall">
                    <h3>How does it work?</h3>
                    <Row>
                        <Col lg="12" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>set your price</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>Choose the amount you want to spend. It can be as little as $50, or as much as $500.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>check the estimate</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>
                                        Look at the estimate of job clicks you will get for your price. Make sure the number works for you and make any necessary adjustments.
                                        </p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col lg="12" className="upward_vertical_getall_wrapper">
                            <div className="clearfix">
                                <div className="upward_vertical_getall_header">
                                    <h4>make it recurring</h4>
                                </div>
                                <div className="upward_vertical_getall_description">
                                    <p>Hiring on an ongoing basis? You can choose to let the job renew at your chosen price when it runs out.</p>
                                </div>
                            </div>
                        </Col>
                    </Row>
                </section>
                <PostToBoards pricing={true} />
                <div className="abstract_wrapper">
                    <Abstract2 />
                </div>
                <section className="pricing_faqs">
                    <h4>
                        FAQs
                        </h4>
                    <p>
                        <span>q: How long will my job be live?</span> <br />
                            a: Your job will be live for 30 days or until your clicks runs out (whichever one comes first). You can see the remaining time and clicks by the job on your job posting.
                        </p>
                    <p>
                        <span>q: Where will my job be posted?</span> <br />
                            a: When you buy an Upward Post, your job is posted to Upward and our network of job sites. Our technology engine chooses the where to get the best applicant exposure for your job. You can also buy posts directly from some top job sites such as Craigslist, Snagajob, ZipRecruiter, and others..
                        </p>
                    <p>
                        <span>q: Are there any other purchasing options?</span> <br />
                            a: If you have more than 100 jobs or want to sponsor jobs on a CPA or CPC then sign up for an <b>enterprise</b> account. <br /><br /> If you would like to speak to a sales representative, contact us at:<br /> (866) 505-2163 or email us at <a href="mailto:sales@upward.net">sales@upward.net</a>
                    </p>
                    <a href="https://upward.freshdesk.com/support/solutions/43000155033" className="moreFAQS">More FAQs</a>
                </section>
            </ModalBody>
        </Modal>
    )

}

export default withRouter(PricingOverlay);